import { createContext, ReactNode, useContext, useEffect } from "react";

export type BreadcrumbsAdjustmentContextProps = {
  register: (path: string, title?: ReactNode | null) => string | number,
  unregister: (id: string | number) => void,
}

export const BreadcrumbsAdjustmentContext = createContext<BreadcrumbsAdjustmentContextProps>({
  register: (path, title) => "",
  unregister: id => {},
});

export function useBreadcrumbsAdjustment(path: string, title?: ReactNode | null) {
  const { register, unregister } = useContext(BreadcrumbsAdjustmentContext);

  useEffect(() => {
    const id = register(path, title);
    return () => unregister(id);
  }, [ path, title, register, unregister ]);
}

export type BreadcrumbsAdjustmentStateType = Map<string | number, ReactNode | null | undefined>

export type BreadcrumbsAdjustmentStateActionType = {
  action: "add",
  path: string,
  title?: ReactNode | null,
} | {
  action: "remove",
  key: string | number
}

export const breadcrumbsAdjustmentReducer = (state: BreadcrumbsAdjustmentStateType, action: BreadcrumbsAdjustmentStateActionType) => {
  switch (action.action) {
    case "add": {
      state.set(action.path, action.title);
      break;
    }
    case "remove": {
      state.delete(action.key);
      break;
    }
  }
  return state;
};